<script setup>
import { ref } from 'vue';
import { useStore } from '@/store/Store.js';
import { GA } from '@/mixins/Ga';
import BtnPill from '@/components/btn/BtnPill.vue';
import { getClient } from '@/core/js/GraphqlClient.js';

const props = defineProps({
    ingredients: {
        type: Array,
        default: () => [],
    },
});

const store = useStore();
const ga = new GA({ category: 'recipeDiscountsIngredients', action: 'clicInterne' });
const client = getClient();
const filteredIngredients = ref([]);

const getDiscountsQuantities = async () => {
    await Promise.all(
        props.ingredients.map(async (ing) => {
            const { data } = await client.executeQuery({
                variables: {
                    lang: store.lang.value,
                    discountsIngredients: ing.id,
                },
                query: `query FetchEntries($lang: [String], $discountsIngredients: [QueryArgument])  {
                        discountsCount: entryCount(section: "discount", site: $lang, relatedTo: $discountsIngredients)
                    }`,
            });
            if (data.discountsCount > 0) {
                filteredIngredients.value.push({
                    discountsCount: data.discountsCount,
                    ...ing,
                });
            }
        }),
    );
};
await getDiscountsQuantities();
</script>

<template>
    <BtnPill
        v-if="filteredIngredients.length > 0"
        v-on:click="ga.send({ label: 'Ingrédients en rabais' })"
    >
        <template #label>
            <span class="md:hidden">Ingrédients en rabais</span>
            <span class="hidden md:inline">Contient des ingrédients en rabais</span>
        </template>
        <template #text>
            <template
                v-for="(ingredient, index) in filteredIngredients"
                :key="index"
            >
                <span>{{ ingredient.title }}<span v-if="index + 1 !== filteredIngredients.length">, </span></span>
            </template>
        </template>
    </BtnPill>
</template>
